import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Logo from './Logo';

const useStyles = makeStyles({
  footer: {
    color: "#7f9baa",
    fontSize: ".75rem",
    paddingTop: "50px",
    paddingBottom: "50px",
  },
  paddingRight: {
    paddingRight: "16px",
  },
});

export default function Footer() {
  const classes = useStyles();
  return (
    <Fragment>
      <Grid container className={classes.footer}>
        <Grid item lg={9} className={classes.paddingRight}>
          <p>Danske Bank A/S, Bernstorffsgade 40, DK-1577 Copenhagen V. Tel. (+45) 70 123 456, e-mail: danskebank@danskebank.dk, CVR No. 61126228, SWIFT: DABADKKK.
            <br /><br />
            Danske Bank reserves all rights. Danske Bank A/S is authorised by the Danish Financial Supervisory Authority.
            <br />
            Department responsible for complaints: Danske Bank, Legal Department, Bernstorffsgade 40, DK-1577 Copenhagen V.
            <br /><br />
            You are welcome to contact us if you have questions about how we process personal data - contact our Data Protection Officer, Bernstorffsgade 40, DK-1577 Copenhagen V, e-mail: DPOfunction@danskebank.com
          </p>
        </Grid>
        <Grid item lg={3} >
          <Logo />
        </Grid>
      </Grid>
    </Fragment>
  );
}
